import { useState } from "react"
import { useTranslation } from "react-i18next"
import { ClipboardCopyIcon, CheckIcon } from "@heroicons/react/outline"
import { parseResponseBody } from "./utils"

const T_PREFIX = "lastmile_management.automated_coverage_deactivations.drawer"

export const ResponseBodyViewer = ({ metadata, errorMessage }) => {
  const { i18n } = useTranslation()
  const [copied, setCopied] = useState(false)

  const parsed = parseResponseBody(metadata, errorMessage)

  const displayText =
    parsed.mode === "json"
      ? JSON.stringify(parsed.content, null, 2)
      : parsed.content || ""

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(displayText)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (e) {
      // clipboard API not available — silently ignore; the user can still select+copy
    }
  }

  return (
    <div className="mt-2">
      {parsed.mode === "fallback" && (
        <p className="text-xs text-gray-500 mb-1">
          {i18n.t(`${T_PREFIX}.metadataMissing`)}
        </p>
      )}
      <div className="relative">
        <pre className="bg-gray-50 border border-gray-200 rounded p-3 text-xs overflow-auto max-h-64 whitespace-pre-wrap break-all">
          {displayText}
        </pre>
        <button
          type="button"
          onClick={handleCopy}
          className="absolute top-2 right-2 inline-flex items-center px-2 py-1 text-xs bg-white border border-gray-200 rounded hover:bg-gray-100"
          title={i18n.t(`${T_PREFIX}.copyResponse`)}
        >
          {copied ? (
            <>
              <CheckIcon className="h-3 w-3 mr-1" />
              {i18n.t(`${T_PREFIX}.copied`)}
            </>
          ) : (
            <>
              <ClipboardCopyIcon className="h-3 w-3 mr-1" />
              {i18n.t(`${T_PREFIX}.copyResponse`)}
            </>
          )}
        </button>
      </div>
    </div>
  )
}
